
/**
 * Is the browser mobile or not?
 *
 * @returns {string} "true" or "false"
 */
export const isMobile = () => {

    let agent = navigator.userAgent.toLowerCase();

    let boolValue = (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(agent));

    return String(boolValue);
}